import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Row} from "reactstrap";
import step1 from "../../assets/img/icons/user/step-counting/step-1.png";
import step2 from "../../assets/img/icons/user/step-counting/step-2.png";
import step3 from "../../assets/img/icons/user/step-counting/step-3.png";
import step4 from "../../assets/img/icons/user/step-counting/step-4.png";
import step5 from "../../assets/img/icons/user/step-counting/step-5.png";
import step6 from "../../assets/img/icons/user/step-counting/step-6.png";
import step7 from "../../assets/img/icons/user/step-counting/step-7.png";
import step8 from "../../assets/img/icons/user/step-counting/step-8.png";
import {useHistory} from "react-router-dom";
import moment from "moment/moment";
import Swal from "sweetalert2";

const SelectionListing = (props) => {
    const [userType, setUserType] = useState(props.signedInUser.projectType);
    const history = useHistory();

    useEffect(() => {

        if (props.userData.eventData?.assessmentName && props.userData.eventData?.startTime) {

        } else {
            Swal.fire({
                icon: 'error',
                title: 'Event Lost',
                text: 'Kindly Create Event Again',
                confirmButtonText: 'Proceed',
                allowOutsideClick: false
            }).then(result => {
                if (result.isConfirmed) {

                    history.push("/assessment/info");
                }
            })
        }
    }, []);

    const handleSubmit = () => {
        history.push("/assessment/loading");
    }
    const previous = () => {
        history.goBack();
    }

    return (
        <Container className="my-5">
            <Row>
                <Col lg={3}>
                    <div className="listing-header pt-1">
                        <img src={step1} height={55}/>
                        <span
                            className="text-white">{userType === "progress" ? "Game" : "Assessments"} Information</span>
                    </div>
                    <div className="mt-3">
                        <div>
                            <label className="games-listing">{props.userData.eventData?.assessmentName}</label>
                        </div>
                        <div>
                            <label
                                className="games-listing mt-2">{props.userData.eventData?.assessmentFor}</label>
                        </div>
                        {props.userData.eventData?.candidateFlow &&
                            <div>
                                <label
                                    className="games-listing mt-2">Candidate Flow</label>
                            </div>
                        }
                    </div>
                </Col>
                <Col lg={3}>
                    <div className="listing-header pt-1">
                        <img src={step2} height={55}/>
                        <span
                            className="text-white">Behavioral {userType === "progress" ? "Competency" : "Assessments"}</span>
                    </div>
                    <div className="mt-3">
                        {props.userData.eventData?.selectedLevels.competencies.map((level, index) => (
                            <div key={index}>
                                <label className="games-listing mb-2">{level.name}</label>
                            </div>
                        ))}
                    </div>
                </Col>
                {userType === "progress" ?
                    <>
                        <Col lg={3}>
                            <div className="listing-header pt-1">
                                <img src={step3} height={55}/>
                                <span className="text-white">Mini Games</span>
                            </div>
                            <div className="mt-3">
                                {props.userData.eventData?.selectedLevels.games.map((level, index) => (
                                    <div key={index}>
                                        <label className="games-listing mb-2">{level.name}</label>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </> :
                    <>
                        <Col lg={3}>
                            <div className="listing-header pt-1">
                                <img src={step3} height={55}/>
                                <span className="text-white">Cognitive Games</span>
                            </div>
                            <div className="mt-3">
                                {props.userData.eventData?.selectedLevels.cognitive.map((level, index) => (
                                    <div key={index}>
                                        <label className="games-listing mb-2">{level.name}</label>
                                    </div>
                                ))}
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="listing-header pt-1">
                                <img src={step4} height={55}/>
                                <span className="text-white">Aptitude Games</span>
                            </div>
                            <div className="mt-3">
                                {props.userData.eventData?.selectedLevels.aptitude.map((level, index) => (
                                    <div key={index}>
                                        <label className="games-listing mb-2">{level.name}</label>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </>
                }
                {/*</Row>*/}
                {/*<Row className="">*/}
                <Col lg={3}>
                    <div className="listing-header pt-1">
                        <img src={userType === "progress" ? step4 : step5} height={55}/>
                        <span className="text-white">Registration Fields</span>
                    </div>
                    <div className="mt-3">
                        {props.userData.eventData?.registrationFields.map((field, index) => (
                            <div key={index}>
                                <label className="games-listing mb-2 text-capitalize">
                                    {field === "fullName" ? "Full Name" :
                                        field === "dateOfBirth" ? "Date of Birth" :
                                            field
                                    }
                                </label>
                            </div>
                        ))}
                    </div>
                </Col>
                <Col lg={3}>
                    <div className="listing-header pt-1">
                        <img src={userType === "progress" ? step5 : step6} height={55}/>
                        <span className="text-white">Login Methods</span>
                    </div>
                    <div className="mt-3">
                        {props.userData.eventData?.loginMethod.map((method, index) => (
                            <div key={index}>
                                <label className="games-listing mb-2 text-capitalize">{method}</label>
                            </div>
                        ))}
                    </div>
                </Col>
                <Col lg={3}>
                    <div className="listing-header pt-1">
                        <img src={userType === "progress" ? step6 : step7} height={55}/>
                        <span className="text-white">Customize Artwork</span>
                    </div>
                    <div className="mt-3">
                        <label className="games-listing mb-2 text-capitalize">
                            {props.userData.eventData?.companyLogo &&
                                `${props.userData.eventData?.assessmentName}-${props.userData.eventData?.assessmentFor}-logo`
                            }
                        </label>
                    </div>
                    <div className="mt-3">
                        {props.userData.eventData?.introVideo &&
                            <label className="games-listing mb-2 text-capitalize">
                                {props.userData.eventData?.assessmentName}-${props.userData.eventData?.assessmentFor}-Intro-Video
                            </label>
                        }
                    </div>
                </Col>
                <Col lg={3}>
                    <div className="listing-header pt-1">
                        <img src={userType === "progress" ? step7 : step8} height={55}/>
                        <span className="text-white">Configure & Launch</span>
                    </div>
                    <div className="mt-3">
                        <label className="list-item-heading">Start Time</label>
                        <div>
                            <label
                                className="games-listing">{moment(props.userData.eventData?.startTime).format('YYYY-MM-DD hh:mm:ss')}</label>
                        </div>
                        <label className="list-item-heading">End Time</label>
                        <div>
                            <label
                                className="games-listing mt-2">{moment(props.userData.eventData?.endTime).format('YYYY-MM-DD hh:mm:ss')}</label>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm={12} xs={12} md={3} lg={3}>
                    <Button className="previous-button text-white w-100" onClick={previous}
                            color="">Previous</Button>
                </Col>
                <Col sm={12} xs={12} md={6} lg={6}></Col>
                <Col sm={12} xs={12} md={3} lg={3}>
                    <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                            onClick={handleSubmit}
                            color="">Next</Button>
                </Col>
            </Row>
        </Container>
    );
};

export default SelectionListing;
